import { Dom } from "@/lib/utils/dom"

ko.bindingHandlers["photo-upload"] =
   init: (element, valueAccessor) ->
      fileContent = valueAccessor()

      handler = =>
         file = element.files[0]
         # Opening the file picker then canceling will trigger a 'change'
         # event without actually picking a file.
         if file == undefined
            fileContent(null)
            return
         # Pass the actual File object instead of reading as data URL
         # This allows the component to upload to S3 via AttachmentStore
         fileContent(file)

      ko.utils.registerEventHandler element, 'change', handler